import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Companion_instance13way2il9a8jt as Companion_instance,
  Enum3alwj03lh1n41 as Enum,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { JsonNames3i9ju5gyx18ko as JsonNames } from '../../../../../kotlinx-serialization-kotlinx-serialization-json/kotlinx/serialization/json/JsonAnnotations.mjs';
import { DataClassPathSerializer2aqs8pcwb13zn as DataClassPathSerializer } from './DataClassPathSerializer.mjs';
import { ConditionSerializer2v4zqxahhdocs as ConditionSerializer } from './ConditionSerialization.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function _get_$cachedSerializer__te6jhj($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function UpdateRestrictions$Mode$Companion$_anonymous__92rtfc() {
  return createSimpleEnumSerializer('com.lightningkite.services.database.UpdateRestrictions.Mode', values());
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  Mode_Blacklist_instance = new (Mode())('Blacklist', 0);
  Mode_Whitelist_instance = new (Mode())('Whitelist', 1);
  if (Companion_instance_0 === VOID) {
    Companion_instance;
    new (Companion())();
  }
}
var Mode_Blacklist_instance;
var Mode_Whitelist_instance;
function values() {
  static_init();
  return [Mode_Blacklist_getInstance(), Mode_Whitelist_getInstance()];
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, UpdateRestrictions$Mode$Companion$_anonymous__92rtfc);
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance() {
  static_init();
  return Companion_instance_0;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.UpdateRestrictions.Part', null, 3);
        tmp0_serialDesc.addElement_5pzumi_k$('property', false);
        tmp0_serialDesc.addElement_5pzumi_k$('requires', false);
        tmp0_serialDesc.addElement_5pzumi_k$('limitedTo', false);
        this.$cachedDescriptor_1 = tmp0_serialDesc;
      }
      serializer_qelnde_k$(typeSerial0) {
        return $serializer().new_com_lightningkite_services_database_UpdateRestrictions_Part_$serializer_j47oct_k$(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_1;
function Companion_getInstance_0() {
  if (Companion_instance_1 === VOID)
    new (Companion_0())();
  return Companion_instance_1;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        return new.target.new_com_lightningkite_services_database_UpdateRestrictions_Part_$serializer_knbwi5_k$();
      }
      static new_com_lightningkite_services_database_UpdateRestrictions_Part_$serializer_knbwi5_k$() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.UpdateRestrictions.Part', $this, 3);
        tmp0_serialDesc.addElement_5pzumi_k$('property', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (JsonNames())(['path']));
        tmp0_serialDesc.addElement_5pzumi_k$('requires', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (JsonNames())(['limitedIf']));
        tmp0_serialDesc.addElement_5pzumi_k$('limitedTo', false);
        $this.descriptor_1 = tmp0_serialDesc;
        return $this;
      }
      serialize_63w3dx_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, new (DataClassPathSerializer())(this.typeSerial0__1), value.property_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, new (ConditionSerializer())(this.typeSerial0__1), value.requires_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, new (ConditionSerializer())(this.typeSerial0__1), value.limitedTo_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_63w3dx_k$(encoder, value instanceof Part() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp7_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, new (DataClassPathSerializer())(this.typeSerial0__1), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, new (ConditionSerializer())(this.typeSerial0__1), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, new (ConditionSerializer())(this.typeSerial0__1), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, new (DataClassPathSerializer())(this.typeSerial0__1), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, new (ConditionSerializer())(this.typeSerial0__1), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, new (ConditionSerializer())(this.typeSerial0__1), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp7_input.endStructure_1xqz0n_k$(tmp0_desc);
        return Part().new_com_lightningkite_services_database_UpdateRestrictions_Part_h4igjo_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [new (DataClassPathSerializer())(this.typeSerial0__1), new (ConditionSerializer())(this.typeSerial0__1), new (ConditionSerializer())(this.typeSerial0__1)];
      }
      typeParametersSerializers_fr94fx_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.typeSerial0__1];
      }
      static new_com_lightningkite_services_database_UpdateRestrictions_Part_$serializer_j47oct_k$(typeSerial0) {
        var $this = this.new_com_lightningkite_services_database_UpdateRestrictions_Part_$serializer_knbwi5_k$();
        $this.typeSerial0__1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
function UpdateRestrictions$Companion$$childSerializers$_anonymous__nj9tp6() {
  return Companion_getInstance().serializer_9w0wvi_k$();
}
var ModeClass;
function Mode() {
  if (ModeClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'Mode', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    ModeClass = $;
  }
  return ModeClass;
}
var PartClass;
function Part() {
  if (PartClass === VOID) {
    class $ {
      constructor(property, requires, limitedTo) {
        Companion_getInstance_0();
        this.property_1 = property;
        this.requires_1 = requires;
        this.limitedTo_1 = limitedTo;
      }
      toString() {
        return 'Part(property=' + this.property_1.toString() + ', requires=' + toString(this.requires_1) + ', limitedTo=' + toString(this.limitedTo_1) + ')';
      }
      hashCode() {
        var result = this.property_1.hashCode();
        result = imul(result, 31) + this.requires_1.hashCode() | 0;
        result = imul(result, 31) + this.limitedTo_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Part()))
          return false;
        if (!this.property_1.equals(other.property_1))
          return false;
        if (!this.requires_1.equals(other.requires_1))
          return false;
        if (!this.limitedTo_1.equals(other.limitedTo_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_UpdateRestrictions_Part_h4igjo_k$(seen0, property, requires, limitedTo, serializationConstructorMarker) {
        Companion_getInstance_0();
        if (!(7 === (7 & seen0))) {
          throwMissingFieldException(seen0, 7, Companion_getInstance_0().$cachedDescriptor_1);
        }
        var $this = createThis(this);
        $this.property_1 = property;
        $this.requires_1 = requires;
        $this.limitedTo_1 = limitedTo;
        return $this;
      }
    }
    initMetadataForClass($, 'Part', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_0});
    PartClass = $;
  }
  return PartClass;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      constructor() {
        Companion_instance_2 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [lazy(tmp_0, UpdateRestrictions$Companion$$childSerializers$_anonymous__nj9tp6), null];
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.UpdateRestrictions', null, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('mode', true);
        tmp0_serialDesc.addElement_5pzumi_k$('fields', false);
        this.$cachedDescriptor_1 = tmp0_serialDesc;
      }
      serializer_qelnde_k$(typeSerial0) {
        return $serializer_0().new_com_lightningkite_services_database_UpdateRestrictions_$serializer_1z5rxp_k$(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_2;
function Companion_getInstance_1() {
  if (Companion_instance_2 === VOID)
    new (Companion_1())();
  return Companion_instance_2;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        return new.target.new_com_lightningkite_services_database_UpdateRestrictions_$serializer_emd1gt_k$();
      }
      static new_com_lightningkite_services_database_UpdateRestrictions_$serializer_emd1gt_k$() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.UpdateRestrictions', $this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('mode', true);
        tmp0_serialDesc.addElement_5pzumi_k$('fields', false);
        $this.descriptor_1 = tmp0_serialDesc;
        return $this;
      }
      serialize_slq25m_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_1().$childSerializers_1;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !value.mode_1.equals(Mode_Blacklist_getInstance())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, tmp2_cached[0].get_value_j01efc_k$(), value.mode_1);
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, new (ArrayListSerializer())($serializer().new_com_lightningkite_services_database_UpdateRestrictions_Part_$serializer_j47oct_k$(this.typeSerial0__1)), value.fields_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_slq25m_k$(encoder, value instanceof UpdateRestrictions() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp7_cached = Companion_getInstance_1().$childSerializers_1;
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp7_cached[0].get_value_j01efc_k$(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, new (ArrayListSerializer())($serializer().new_com_lightningkite_services_database_UpdateRestrictions_Part_$serializer_j47oct_k$(this.typeSerial0__1)), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp7_cached[0].get_value_j01efc_k$(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, new (ArrayListSerializer())($serializer().new_com_lightningkite_services_database_UpdateRestrictions_Part_$serializer_j47oct_k$(this.typeSerial0__1)), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return UpdateRestrictions().new_com_lightningkite_services_database_UpdateRestrictions_2hafrr_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [Companion_getInstance_1().$childSerializers_1[0].get_value_j01efc_k$(), new (ArrayListSerializer())($serializer().new_com_lightningkite_services_database_UpdateRestrictions_Part_$serializer_j47oct_k$(this.typeSerial0__1))];
      }
      typeParametersSerializers_fr94fx_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.typeSerial0__1];
      }
      static new_com_lightningkite_services_database_UpdateRestrictions_$serializer_1z5rxp_k$(typeSerial0) {
        var $this = this.new_com_lightningkite_services_database_UpdateRestrictions_$serializer_emd1gt_k$();
        $this.typeSerial0__1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
function Mode_Blacklist_getInstance() {
  static_init();
  return Mode_Blacklist_instance;
}
function Mode_Whitelist_getInstance() {
  static_init();
  return Mode_Whitelist_instance;
}
var UpdateRestrictionsClass;
function UpdateRestrictions() {
  if (UpdateRestrictionsClass === VOID) {
    class $ {
      constructor(mode, fields) {
        Companion_getInstance_1();
        mode = mode === VOID ? Mode_Blacklist_getInstance() : mode;
        this.mode_1 = mode;
        this.fields_1 = fields;
      }
      toString() {
        return 'UpdateRestrictions(mode=' + this.mode_1.toString() + ', fields=' + toString(this.fields_1) + ')';
      }
      hashCode() {
        var result = this.mode_1.hashCode();
        result = imul(result, 31) + hashCode(this.fields_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof UpdateRestrictions()))
          return false;
        if (!this.mode_1.equals(other.mode_1))
          return false;
        if (!equals(this.fields_1, other.fields_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_UpdateRestrictions_2hafrr_k$(seen0, mode, fields, serializationConstructorMarker) {
        Companion_getInstance_1();
        if (!(2 === (2 & seen0))) {
          throwMissingFieldException(seen0, 2, Companion_getInstance_1().$cachedDescriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.mode_1 = Mode_Blacklist_getInstance();
        else
          $this.mode_1 = mode;
        $this.fields_1 = fields;
        return $this;
      }
    }
    initMetadataForClass($, 'UpdateRestrictions', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_1});
    UpdateRestrictionsClass = $;
  }
  return UpdateRestrictionsClass;
}
//region block: exports
export {
  $serializer_0 as $serializer3begl8eud4mug,
  UpdateRestrictions as UpdateRestrictions32h9nfoepzv9j,
  Companion_getInstance_1 as Companion_getInstance1mj22e08iawmm,
  Companion_getInstance_0 as Companion_getInstancelevea1paw68a,
};
//endregion

//# sourceMappingURL=UpdateRestrictions.mjs.map
